/** Grid en pantalla pequeña; fila horizontal desde xl (junto al sidebar fijo). */
export const PO_ITEM_ROW =
  'grid w-full min-w-0 grid-cols-2 gap-x-2 gap-y-3 sm:grid-cols-4 xl:flex xl:flex-nowrap xl:items-start xl:gap-1.5';

export const POIC = {
  product: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[5.5rem]',
  service: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[5.5rem]',
  description: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[4.5rem]',
  /** Sin columna proyecto en la fila (proyecto global activo). */
  productWide: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-[2] xl:min-w-[8rem]',
  unit: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-28 xl:min-w-[7rem]',
  project: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[9rem]',
  qty: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-20 xl:min-w-[4.5rem]',
  price: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:flex-1 xl:min-w-[7rem]',
  igv: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-16 xl:min-w-[3.5rem]',
  subtotal: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-[7rem]',
  saleType: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[8rem]',
  actions: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-8',
};
